import React from 'react';
import HeaderBottomOne from '../common/header/HeaderBottomOne';
import FooterOne from '../common/footer/FooterOne';

const Instagram = () => {

    return (
        <>
            <HeaderBottomOne />
            <div className="container" style={{ paddingTop: '60px', paddingBottom: '60px' }}>
                <div className="section-title text-center mb-50">
                    <h4>Ακολουθήστε μας</h4>
                    <h2>Instagram</h2>
                    <p>@ratatouille_cuisine_serres</p>
                </div>
                <div
                    className="elfsight-app-4f7c8c9a-c9f0-469b-9df5-8138632b6c01"
                    data-elfsight-app-lazy
                />
            </div>
            <FooterOne />
        </>
    );
};

export default Instagram;
